import {
    ADD_TIPS_AMOUNT_START,
    ADD_TIPS_AMOUNT_SUCCESS,
    ADD_TIPS_AMOUNT_ERROR
} from '../../constants';
import { updateTips as mutation, getBookingById as query } from '../../lib/graphql/booking';
import showToaster from '../../helpers/toastrMessgaes/showToaster';
import { closeHeaderModal } from '../siteadmin/modalActions';
import { setLoaderStart, setLoaderComplete } from '../loader/loader';

export function addTipsAmountAction({ bookingId, currency, amount, paymentType }) {

    return async (dispatch, getState, { client }) => {
        try {
            dispatch(setLoaderStart('addTips'));

            dispatch({
                type: ADD_TIPS_AMOUNT_START,
            });

            const { data } = await client.mutate({
                mutation,
                variables: {
                    bookingId,
                    currency,
                    amount: Number(amount),
                    paymentType,
                    isUpdateTip: true
                },
                refetchQueries: [
                    {
                        query,
                        variables: {
                            bookingId
                        },
                    }
                ]
            });
            dispatch(setLoaderComplete('addTips'));

            if (data?.updateTips?.status === 200) {
                dispatch({
                    type: ADD_TIPS_AMOUNT_SUCCESS,
                });
                dispatch(closeHeaderModal('addTipsForm'));
            } else {
                dispatch({
                    type: ADD_TIPS_AMOUNT_ERROR,
                    payload: {
                        error: data?.cancelBooking?.errorMessage,
                    },
                });
                await showToaster({ messageId: 'errorMessage', toasterType: 'error', requestContent: data?.updateTips?.errorMessage })
            }
        } catch (error) {
            dispatch({
                type: ADD_TIPS_AMOUNT_ERROR,
                payload: {
                    error,
                },
            });
            return false;
        }
        return true;
    };
}
